import { xhr } from "../../../client/helper";

const form = document.querySelector('.article-parse__form');
const result = document.querySelector('.article-parse__result');


if (form) {
    let hasSend = false;

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const url = data.get('url');

        if (url) {
            xhr('GET', '/api/article-parser/?url='+ url).then(response => {
                if (response.success && result) {
                    result.innerHTML = response.page;
                }
            });
        }
    });
}
